<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="方案录入" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="录入方案" >
                <el-select v-model="formData.dealWay" style="width:10vw!important;"
                  clearable>
                  <el-option v-for="item in dealWayList" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人工确认方案" >
                <el-input type="textarea" autocomplete="off" v-model="formData.confirmWay"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  :diabled="siteAppealButton" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderNo', 'exchangeOrderId', 'wf'],
  created() {
    this.formData.id = this.exchangeOrderId
  },
  data() {
    return {
      uploadFileUrl: api.uploadFileUrl,

      siteAppealButton: false,

      dealWayList: [],
      exchangeNo: '',

      formData: {
        id: null,
        processId: null,
        taskId: null,
        dealWay: null,
        dealWayName: null,
        messageContent:null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    // 考核的确认
    siteAppeal() {
      let dealWay = this.formData.dealWay;
      if (dealWay) {
        this.dealWayList.forEach(item => {
          if (dealWay === item.value) {
            this.formData.dealWayName = item.label
          }
        })
      }

      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: "/basic/wkExchangeOrder/schemeEntry",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('确认成功')
          this.$emit('closeDialog',true)
        }).catch(() => {
          this.$mask.close()
        })
      })
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("处理方案名称").then(res => {
        this.dealWayList = []
        let defaultDealWay = null;
        res.data.data.forEach(item => {
          this.dealWayList.push({
            label: item.label,
            value: item.id
          })
          if (item.label === "退货结算") {
            defaultDealWay = item.id;
          }
        })
        if (defaultDealWay) {
          this.formData.dealWay = defaultDealWay
        }
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDialog', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
